import React from 'react';
import { mockProjects } from '../../data/mockData';
import Badge from '../ui/Badge';
import SafeIcon from '../../common/SafeIcon';

export default function Projects() {
  return (
    <div className="animate-in fade-in duration-500">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-light text-cream">Project Budgets</h1>
          <p className="text-sm text-cream-muted mt-1">Track spend and team capacity across active projects.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {mockProjects.map(project => {
          const budgetPercent = (project.spent / project.budget) * 100;
          const isOverBudget = budgetPercent > 100;
          const isAtRisk = budgetPercent > 85;

          return (
            <div key={project.id} className="glass-panel rounded-xl p-5 hover:border-[#444] transition-colors">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <h3 className="text-lg font-medium text-cream">{project.name}</h3>
                    <Badge variant={project.status === 'Active' ? 'success' : 'warning'}>{project.status}</Badge>
                  </div>
                  <p className="text-sm text-cream-muted">{project.client}</p>
                </div>
                
                <div className="flex gap-8 text-right">
                  <div>
                    <p className="text-xs text-cream-muted mb-1">Budget Spent</p>
                    <p className="font-mono text-cream">${project.spent.toLocaleString()} <span className="text-cream-muted text-sm">/ ${project.budget.toLocaleString()}</span></p>
                  </div>
                  <div>
                    <p className="text-xs text-cream-muted mb-1">Team Capacity</p>
                    <p className="font-mono text-cream">{project.capacity}%</p>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <div className="flex justify-between text-xs mb-1.5">
                    <span className="text-cream-muted">Budget Utilization</span>
                    <span className={isOverBudget ? 'text-red-400' : isAtRisk ? 'text-yellow-500' : 'text-invoice-green'}>
                      {budgetPercent.toFixed(1)}%
                    </span>
                  </div>
                  <div className="h-2 w-full bg-charcoal-base rounded-full overflow-hidden">
                    <div 
                      className={`h-full rounded-full transition-all duration-1000 ${isOverBudget ? 'bg-red-500' : isAtRisk ? 'bg-yellow-500' : 'bg-invoice-green'}`}
                      style={{ width: `${Math.min(budgetPercent, 100)}%` }}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}